// extracted by mini-css-extract-plugin
module.exports = {"documentGroup":"YsKTzSVL","lockDuringUpload":"OxGC23dZ"};